import React from 'react';
import packageJson from '../package.json';
global.appVersion = packageJson.version;
 
// version from response - first param, local version second param
const semverGreaterThan = (versionA, versionB) => {
 if (!versionA || !versionB) return false;
 const versionsA = versionA.split(/\./g);
 
 const versionsB = versionB.split(/\./g);
 while (versionsA.length || versionsB.length) {
   const a = Number(versionsA.shift());
 
   const b = Number(versionsB.shift());
   // eslint-disable-next-line no-continue
   if (a === b) continue;
   // eslint-disable-next-line no-restricted-globals
   return a > b || isNaN(b);
 }
 return false;
};
 
class CacheBuster extends React.Component {
 constructor(props) {
   super(props);
   this.state = {
     // Do not block initial paint; run version check in background.
     loading: false,
     isLatestVersion: true,
      refreshCacheAndReload: () => {
        var timeout1 = 100; // clear cache
        var timeout2 = 6000; // refresh browser
        if (typeof window !== "undefined" && window.caches) {
        setTimeout(function () {
          // Service worker cache should be cleared with caches.delete()

           console.log('Refresh Cache : Step 1');

           if (window.caches) {

               window.caches.keys().then(async(names) => {
                  console.log(names.length + ' keys found');

                  // eslint-disable-next-line no-restricted-syntax
                  for (var _i = 0, names_1 = names; _i < names_1.length; _i++) {
                      var name_1 = await names_1[_i];
                      await window.caches.delete(name_1);
                      console.log(name_1 + ' keys removed');
                  }
              });
          }
      }, timeout1);
    }

      setTimeout(function () {
                    
        console.log('Refresh Cache : Step 2');
            // clear browser cache and reload page                
            window.location.reload();
        
    }, timeout2);
      //  console.log('Clearing cache and hard reloading...')
      //  if (caches) {
      //    // Service worker cache should be cleared with caches.delete()
      //    caches.keys().then(function(names) {
      //      for (let name of names) caches.delete(name);
      //    });
      //  }
 
      //  // delete browser cache and hard reload
      //  window.location.reload(true);
     }
   };
 }
 
 componentDidMount() {
   const controller = new AbortController();
   const timeoutId = setTimeout(() => controller.abort(), 1200);

   fetch(`/meta.json?${new Date().getTime()}`, { cache: 'no-cache', signal: controller.signal })
     .then((response) => response.json())
     .then((meta) => {
       const latestVersion = meta.version;
       const currentVersion = global.appVersion;
 
       const shouldForceRefresh = semverGreaterThan(latestVersion, currentVersion);
       if (shouldForceRefresh) {
         console.log(`We have a new version - ${latestVersion}. Should force refresh`);
         this.setState({ isLatestVersion: false });
       } else {
         console.log(`You already have the latest version - ${latestVersion}. No cache refresh needed.`);
         this.setState({ isLatestVersion: true });
       }
     })
     .catch(() => {
       // Keep app interactive even if version check endpoint is slow/unavailable.
       this.setState({ isLatestVersion: true });
     })
     .finally(() => {
       clearTimeout(timeoutId);
     });
 }
 render() {
   const { loading, isLatestVersion, refreshCacheAndReload } = this.state;
   return this.props.children({ loading, isLatestVersion, refreshCacheAndReload });
 }
}
 
export default CacheBuster;